/* eslint-disable indent */
<!--  -->
<template>
  <div>
    <div class>
         <Steps :active="2" :stepsShow=true align-center>
             <Step :title="$t('course.csbase')" @click.native="on_click('csbaseShow')" />
             <Step :title="$t('course.cscondition')" @click.native="on_click('csconditionShow')"/>
             <Step :title="$t('course.csprice')" @click.native="on_click('cspriceShow')" />
             <Step :title="$t('course.csrpt')" @click.native="on_click('csrptShow')" />
             <Step :title="$t('course.csinvest')" @click.native="on_click('csinvestShow')" />
             <Step :title="$t('course.csability')" @click.native="on_click('csabilityShow')" />
            </Steps>
    </div>
    <br/>
    <div class='divMessage' style=" word-wrap:break-word; word-break:break-all;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ message }}</div>
    <br/>
    <div>
     <el-card class="aui-card--fill"
           shadow="never">
        <el-form
                label-position="top"
                label-width="180px"
                :model="inServForm"
                ref="inServForm"
                :rules="dataRule"
                size="small">
          <el-row >
            <el-col :span="6">
              <!--价格(￥) -->
              <el-form-item :label="$t('couse.courseprice')" prop="coursePrice">
                <span slot="label">{{$t('couse.courseprice')}}
                  <el-tooltip placement="bottom-start" effect="light" >
                    <div slot="content">
                      若课程无需付费，课程价格填写为0；若课程需付费，课程价格=课程单价*标准时长（天）
                    </div>
                    <em class="el-icon-question" style="color: #1C69D3"></em>
                  </el-tooltip>
                </span>
                <el-input v-model.number="inServForm.coursePrice" oninput="value=value.replace(/[^\d.]/g,'')" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 奖励积分 -->
              <el-form-item :label="$t('couse.rewardscore') " >
                <el-input v-model="inServForm.rewardScore" oninput="value=value.replace(/[^\.\d]/g,'')" disabled></el-input>
              </el-form-item>
            </el-col>
                 <el-col :span="6">
            <!-- 缺勤扣款(￥) -->
              <el-form-item :label="$t('couse.noshowpenalty')" prop="noShowPenalty">
                <span slot="label">{{$t('couse.noshowpenalty')}}
                  <el-tooltip placement="bottom-start" effect="light" >
                    <div slot="content">
                      <p>1. 无需付费课程，缺勤扣款按照每年公布的No Show价格填写。</p>
                      <p>2. 需付费课程，缺勤扣款按照课程价格填写，即缺勤扣款=价格。</p>
                    </div>
                    <em class="el-icon-question" style="color: #1C69D3"></em>
                  </el-tooltip>
                </span>
                <el-input v-model="inServForm.noShowPenalty" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <!-- 消费积分 -->
              <el-form-item :label="$t('couse.consumptionscore')">
                <el-input v-model="inServForm.consumptionScore"
                          class="inputBox" disabled>
                </el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="4"><div class="grid-content bg-purple"></div></el-col>
      <el-col :span="4"><div class="grid-content bg-purple"></div></el-col> -->
          </el-row>
          <el-row>
              <el-col :span="6">
              <!-- '预算号' -->
              <el-form-item :label="$t('couse.budgetline')">
                <el-input v-model="inServForm.budgetLine"
                          class="inputBox" disabled>
                </el-input>
              </el-form-item>
            </el-col>
              <el-col :span="6">
                  <el-form-item :label="$t('couse.whetherreturn')" prop="whetherReturn" style="display: block">
                      <span slot="label">{{$t('couse.whetherreturn')}}
                        <el-tooltip placement="bottom-start" effect="light" >
                          <div slot="content">
                            <p>选择“返还”，学员通过课程后，返还学员报名时的排期价格。学员未通过课程，正常收取费用。</p>
                            <p>选择“不返还”，学员培训后，正常收取费用。</p>
                          </div>
                          <em class="el-icon-question" style="color: #1C69D3"></em>
                        </el-tooltip>
                      </span>
                      <el-select v-model="inServForm.whetherReturn" disabled>
                          <el-option v-for="item in options"
                                     :key="item.value"
                                     :label="item.label"
                                     :value="item.value">
                          </el-option>
                      </el-select>
                  </el-form-item>
              </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('couse.BBASplit')" prop="bbasplit">
                <el-select v-model="inServForm.bbasplit" disabled>
                  <el-option v-for="item in bbasplit"
                             :key="item.value"
                             :label="item.label"
                             :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="150">
            <el-col :span="12">
              <!-- '撤销报名发款' -->
              <el-form-item :label="$t('couse.coureschex')">
                <span slot="label">{{$t('couse.coureschex')}}
                  <el-tooltip placement="bottom-start" effect="light" >
                    <div slot="content">此规则修改仅会同步到未发布的排期，已发布/已关课/已取消状态下的排期不会同步更新。</div>
                    <em class="el-icon-question" style="color: #1c69d3"></em>
                  </el-tooltip>
                </span>
              </el-form-item>
            </el-col>

          </el-row>
          <!-- <el-table :key='tableKey1'
                    :data="inServForm.tableData"
                    id="download"
                    :show-header="false"
                    v-loading.body="listLoading"
                    border
                    stripe
                    empty-text=" "
                    :header-cell-style="tableHeaderColor"> -->
                    <!-- @current-change="handleCurrentChange" -->
          <!-- <el-table :data="inServForm.courseRevokePenaltyList"
                    highlight-current-row
                    style="width: 100%">
            <el-table-column label=""
                            prop="day"
                            align="center"
                            width="400">
              <template slot-scope="scope">
                <spen style="width: 120px; float: left;">{{$t('couse.cousrq')}}</spen>
                <el-input v-model="scope.row.startDays" disabled
                          style="width: 60px; float: left;"></el-input>
                <spen style="width: 80px; float: left;">{{$t('couse.couresday')}}</spen>
                <el-input style="width: 80px; float: left;"
                          v-model="scope.row.penaltyRate" disabled></el-input>
              </template>
            </el-table-column>
            <el-table-column label=""
                            width="100">
            </el-table-column>
          </el-table> -->
            <el-table
                    :data="inServForm.courseRevokePenaltyList"
                    stripe class="spHeight"
                    :show-header="false"
                    border
                 style="width:600px">
                <!-- align="center" header-align="center" -->
                <el-table-column label=""
                                 width="150">
                    <template slot-scope="scope">
                        <!-- style="width: 120px; float: left;" -->
                        <span >{{$t('couse.cousrq')}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="" prop="startDays"
                                 align="center" header-align="center"
                                 width="130">
                    <template slot-scope="scope">
                        <!-- oninput="value=value.replace(/[^\d.]/g,'')" -->
                            <el-input v-model.number="scope.row.startDays" disabled class="el-inputs"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label=""
                                 header-align="center"
                                 align="center"
                                 width="155">
                    <template slot-scope="scope" >
                        <span style="width: 155px;">{{$t('couse.couresday')}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="" prop="penaltyRate"
                                 header-align="center"
                                 align="center" >
                    <template slot-scope="scope" >
                            <!-- 罚款比例 style="width: 80px; float: left;" :formatter="ifendcase"-->
                             <el-col :span="20">
                            <el-input
                                    v-model="scope.row.penaltyRate" disabled></el-input>
                             </el-col>
                            <el-col :span="2" style="line-height: 34px">
                     <span >%</span></el-col>
                    </template>
                </el-table-column>
                <!-- <el-table-column label=""
                                prop="day"
                                align="center"
                                width="400"
                                >
                  <template slot-scope="scope" >
                    <spen style="width: 120px; float: left;">{{$t('couse.cousrq')}}</spen>
                    <el-input v-model.number="scope.row.startDays" oninput="value=value.replace(/[^\d.]/g,'')"
                              style="width: 60px; float: left;"></el-input>
                    <el-form-item :prop="'courseRevokePenaltyList.' + scope.$index + '.penaltyRate'" :rules='dataRule.penaltyRate'>
                    <spen style="width: 80px; float: left;">{{$t('couse.couresday')}}</spen>
                       <el-input style="width: 80px; float: left;"
                              v-model="scope.row.penaltyRate"></el-input>
                       </el-form-item>
                  </template>
                </el-table-column> -->
                <!-- <el-table-column fixed="right"
                                label=""> -->
                <!-- <el-table-column label=""
                                 width="100"    header-align="center"
                                 align="center" >

                </el-table-column> -->
            </el-table>
        </el-form>
      </el-card>
    </div>
      <div>
          <el-row  style="float:right; margin-bottom: 60px;">
              <el-col :span="16"><div class="grid-content" /></el-col>
              <el-button @click="sendEdit" v-if="checkEditRole()"
                         type="primary">{{ $t("course.edit") }}</el-button>
              <el-button @click="send"  type="primary">{{ $t("course.next") }}</el-button>
          </el-row>
      </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
// import coursedcreat from '../csprice/coursedcreat'
// import course from '../../common/course'
import debounce from 'lodash/debounce'
// import condition from './condition'
import Steps from '../../common/steps/index'
import Step from '../../common/steps/src/step'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    Steps,
    Step
    // coursedcreat,
    // course
    // condition
  },
  props: ['message', 'courseid'],
  inject: ['toTop'],
  data () {
    // 这里存放数据
    return {
      // message: '',
      courseId: '',

      initcon: [],
      inServForm: {
        bbasplit:'0',
        courseId: '1',
        courseRevokePenaltyList: [],
        courejoblist: []
      },
      options: [{
            value: '0',
            label: '不返还'
        }, {
            value: '1',
            label: '返还'
        }],

      bbasplit: [
        {
          value: '0',
          label: '无'
        },
      {
          value: '1',
          label: 'BBA Only'
      },
      {
          value: '2',
          label: 'BWM Joint'
      },
      {
          value: '3',
          label: 'NSC Only'
      },
      {
          value: '4',
          label: 'MINI Only'
      },
      {
          value: '5',
          label: 'MOTOR Only'
      }
      ],
    }
  },
  // 监听属性 类似于data概念
  computed: {
    dataRule () {
      return {
        coursePrice: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        noShowPenalty: [
            { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        whetherReturn: [
              { required: true, message: this.$t('validate.required'), trigger: 'blur' }],
        bbasplit: [
              { required: true, message: this.$t('validate.required'), trigger: 'blur' }]
      }
    }

  },
  // 监控data中的数据变化
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    var courseId = this.$route.query.courseId
    this.courseId = courseId
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    this.init()
  },
  beforeCreate () {
    console.log('beforeCreate')
  }, // 生命周期 - 创建之前
  beforeMount () {
    console.log('beforeMount')
  }, // 生命周期 - 挂载之前
  beforeUpdate () {
    console.log('beforeUpdate')
  }, // 生命周期 - 更新之前
  updated () {
    console.log('updated')
  }, // 生命周期 - 更新之后
  beforeDestroy () {
    console.log('beforeDestroy')
  }, // 生命周期 - 销毁之前
  destroyed () {
    console.log('destroyed')
  }, // 生命周期 - 销毁完成
  activated () {
      this.init(this.courseId)
      this.$nextTick(() => {
          //  this.getInfo()
          //  this.$message('这是一条消息提示$$$$')
      })
  },
    init (courseId) {
        this.getCoursePrice(courseId)
    },
    getCoursePrice (courseId) {
        this.inServForm.courseId = this.$route.query.courseId
        if (this.inServForm.courseId === null || this.inServForm.courseId === '') {
            return
        }
        this.$request.get('/learning/courseinfo/list3/' + this.inServForm.courseId
        ).then((res, total, code, data) => {
            if (data.data !== undefined && data.data !== null) {
                this.inServForm = data.data
            }
        }).catch((err) => {
          console.log(err)
        })
    },
  // 方法集合
  methods: {

    send () {
      this.toTop()
      this.$emit('onShowModer', 'csrptShow')
    },
    sendSave () {
      this.$emit('onShowModer', 'csrptSave')
    },
    on_click (e) {
      this.$emit('onShowModer', e)
    },
    // 设置为了空白
    again () {
      this.inServForm.courseRevokePenaltyList = []
      this.inServForm.courseId = ''
      this.inServForm.courseCode = ''
      this.inServForm.coursePrice = ''
      this.inServForm.noShowPenalty = ''
      this.inServForm.rewardScore = ''
      this.inServForm.consumptionScore = ''
      this.inServForm.budgetLine = ''
    },
    // 页面初始化
    init () {
      // this.$message('1111122222' + this.$route.query.courseId)
      // this.dataForm.courseId = this.$route.query.courseId
      // this.getDealerBeforeGetInfo()
      if (this.$route.query.courseId !== undefined) {
        // this.$message('1111122222' + this.$route.query.courseId)
        this.inServForm.courseId = this.$route.query.courseId
        this.getDealerBeforeGetInfo()
      }
    },
    getDealerBeforeGetInfo () {
      // this.$message('33333' + this.inServForm.courseId)
      // this.$request.post(`/learning/course/courseinfo/courseConditionUpdate`,
      this.$request.get('/learning/courseinfo/list3',
        { courseId: this.inServForm.courseId }
      ).then((res, total, code, data) => {
        // this.$message('333331111' + data + res)
        // this.inServForm = data.data
        // this.getInfo()
        if (data.data !== 'undefined' && data.data !== null) {
          this.inServForm = data.data
          var coursePrice = this.inServForm.coursePrice
          var noShowPenalty = this.inServForm.noShowPenalty
          if (coursePrice !== 'undefined' && coursePrice !== null && coursePrice !== '') {
            this.inServForm.coursePrice = coursePrice.toFixed(2)
          }
          if (noShowPenalty !== 'undefined' && noShowPenalty !== null && noShowPenalty !== '') {
            this.inServForm.noShowPenalty = noShowPenalty.toFixed(2)
          }
        }
      }).catch(() => {
        // this.$message('444')
      })
    },

    clickTest (tableData, event) {
      tableData.push({ startDays: '', penaltyRate: '' })
    },

    deleteRow (index, rows) { // 删除改行
      rows.splice(index, 1)
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.inServForm.courseId = this.courseid
      let dataFormModify = JSON.parse(JSON.stringify(this.inServForm))
      // this.$message('1111111' + this.courseid)
      this.$refs['inServForm'].validate((valid) => {
        //  dataFormModify.motherShopId = this.select2 this.$request.post
        this.$request.put(`/learning/courseinfo/courseRevokeUpdate`,
          dataFormModify
        ).then((res, total, code, data) => {
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500

          })
          this.sendMsg()
        }).catch((err) => {
          console.log(err)
        })
      })
    }, 1000, { 'leading': true, 'trailing': false }),
    dataFormSubmitHandle2: debounce(function () {
      this.inServForm.courseId = this.courseid
      let dataFormModify = JSON.parse(JSON.stringify(this.inServForm))
      this.$refs['inServForm'].validate((valid) => {
        //  dataFormModify.motherShopId = this.select2 this.$request.post
        this.$request.put(`/learning/courseinfo/courseRevokeUpdate`,
          dataFormModify
        ).then((res, total, code, data) => {
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500

          })
          this.sendSave()
        }).catch((err) => {
          console.log(err)
        })
      })
    }, 1000, { 'leading': true, 'trailing': false }),
    backPage () {
      this.$router.go(-1)
    },
    sendEdit(){
      console.log("sendEdit")
      this.$router.push({ path: 'learning-course-course', query: { courseId: this.inServForm.courseId } })
    },
    checkEditRole () {
        return   this.$store.state.courseEdit
      // if (this.$hasPermission('learning:courseinfo:edit')) {
      //     return true
      // }
      // if (this.$hasPermission('TEAM:'+this.inServForm.courseTeamCatalogSecond)) {
      //     return true
      // }
      // if (this.$hasPermission('learning:courseinfo:editselfcreated')) {
      //     return true
      // }
      // return false
    },
  }
  // 如果页面有keep-alive缓存功能，这个函数会触发
}
// 表单提交
//   dataFormSubmitHandle2: debounce(function () {
//     let dataFormModify = JSON.parse(JSON.stringify(this.inServForm))
//     this.$refs['inServForm'].validate((valid) => {
//       //  dataFormModify.motherShopId = this.select2 this.$request.post
//       this.$request.put(`/learning/courseinfo/courseRevokeUpdate`,
//               dataFormModify
//       ).then((res, total, code, data) => {
//         this.$message({
//           message: this.$t('prompt.success'),
//           type: 'success',
//           duration: 500

//         })
//       }).catch(() => { })
//     })
//   }, 1000, { 'leading': true, 'trailing': false }),
//   backPage () {
//     this.$router.go(-1)
//   }
// } // 如果页面有keep-alive缓存功能，这个函数会触发
// }

</script>
<style lang='scss' scoped>
 .el-inputs {
    position: relative;
    font-size: 14px;
    display: inline-block;
    width: 100px;
}
.spHeight td{
  height: 23px;
}
.c-11 {
  border-radius: 50%;
  border: 15px solid;
  border-color: inherit;
}
.el-table .warning-row {
  /*//background: oldlace;*/
  background: oldlace;
}

.el-table .success-row {
  background: #fbf4ff;
}
* {
  padding: 0;
  margin: 0;
}
.box {
  height: 40px;
  background: cyan;
}
.nav {
  line-height: 40px;
  display: inline-block;
  margin-left: 100px;
  cursor: pointer;
}
.red {
  color: red;
  /*background: red;*/
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.el-row {
  margin-bottom: 20px;
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 20px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
#container {
  overflow: hidden;
} /* 清除浮动 */

/* #container div{height:100px;} */
#container div {
  width: 100px;
  display: inline-block;
}

.box1 {
  background: red;
  float: left;
}
.box12 {
  float: right;
}
.box2 {
  background: green;
  float: left;
}
.box3 {
  float: left;
}
</style>
